import { render, staticRenderFns } from "./coaching_journal_edit.vue?vue&type=template&id=107da045&"
import script from "./coaching_journal_edit.vue?vue&type=script&lang=js&"
export * from "./coaching_journal_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports